"use client";

import Header from "../header/page";
import PassPage from "./pass-page";
import "./botb-pass.css";
import { useEffect, useState } from "react";
import "../home/homepageCompetitions/homepageCompetitions.css";
import DOMPurify from "dompurify";
import { getUserSubscriptionPlan } from "../subscription/subscription-service";

const BotBPass = () => {
  const [mileStones, setMileStones] = useState<string>("");
  useEffect(() => {
    getUserSubscriptionPlan()
      .then(res => res.json())
      .then(res => {
        if (res !== null) {
          location.href = "/botb-pass-members";
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, []);
  return (
    <>
      <header className="sticky top-0 bg-white z-[1003] botb-pass-header">
        <Header
          renderModalComponentHere={false}
          isBotBPassHeader={true}
          milestoneData={DOMPurify.sanitize(mileStones)}
        />
      </header>
      <PassPage updateMilestones={setMileStones} />
    </>
  );
};

export default BotBPass;
